import { render, staticRenderFns } from "./ModalSendInvoice.vue?vue&type=template&id=bb8dd524&"
import script from "./ModalSendInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalSendInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendInvoice.vue?vue&type=style&index=0&id=bb8dd524&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports